import React from "react"
import DiversificationImg from "./DiversificationImg"

export default function Diversification() {
  return (
    <div
      className="row justify-content-around align-items-center py-5"
      id="diversification"
    >
      <div className="col-lg-5 mobile-padding">
        <DiversificationImg />
      </div>
      <div className="col-lg-4 mobile-padding">
        <h3>Diversification</h3>
        <p>
          Typically, average investors were only able to invest into the stock
          market, giving no real protection against assets directly correlated
          to it. Now, investors can diversify their portfolios with real
          alternative assets, like agriculture.
        </p>
      </div>
    </div>
  )
}
